import styled, { css } from "styled-components";
export const Container = styled.div``;

export const BadgeContainer = styled.div`
  background-color: transparent;
  border-radius: 2px;
  text-transform: uppercase;
  text-align: center;
  font-weight: bold;
  min-width: 150px;
  border-radius: 5px;
  word-wrap: break-word;
  /* margin-left: 0px !important; */
  cursor: pointer;
  & > div {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 0px !important;
  }
  ${(props) =>
    props.bgColor &&
    css`
      background-color: ${props.bgColor};
  `}

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
  `}

  ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize};
    `}

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.4;
      cursor: default;
  `}

  padding: 4px 8px 4px 8px;
  ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize};
    `}
`;

export const ContentButton = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
`
